// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "" + (chunkId === 293 ? "component---src-pages-index-js" : chunkId) + "-" + {"108":"39761238349d407f1934","293":"916db129b42f67fd4eb4","452":"e7d8c2d1f0f1f7331b70"}[chunkId] + ".js";
};